<div class="container-fluid">
  <div class="row mt-3 pt-1 pb-1 mb-1">
    <div class="col-12">
      <div class="d-flex flex-row justify-content-start">
        <div><i class="fal fa-spin fa-circle-notch"></i></div>
        <div class="d-inline-block ml-2 mr-2">Running Pipelines</div>
      </div>
    </div>
  </div>

  <div *ngIf="!pipelines || pipelines.length === 0" class="row pipeline mt-1 pt-1 pb-1">
    <div class="col-12">No active pipelines found or loaded yet</div>
  </div>

  <div class="row">

    <div *ngFor="let item of pipelines; even as even" class="col-6 mt-1 pt-1 pb-1">
      <div [ngClass]="[item.pipeline.status, !even ? 'ml' : '']" class="row pipeline">
        <div class="col-3">
          <div class="project">{{item.project.name_with_namespace}}</div>
          <div class="ml-2 branch">
            <div class="d-inline-block mr-1"><i class="fal fa-code-branch"></i></div>
            <div class="d-inline-block">{{item.pipeline.ref}}</div>
            <div (mouseenter)="item.hover = true" (mouseleave)="item.hover = false" class="d-inline-block ml-3 track">
              <a (click)="track(item)" title="track branch"><i [ngClass]="[item.hover ? 'fas' : 'fal']"
                                                               class="fa-thumbtack"></i></a></div>
          </div>
          <div class="ml-2 commit">
            {{item.commit.title}}
          </div>
        </div>
        <div class="col-3">
          <div>
            <div class="d-inline-block started">{{item.pipeline.created_at | date: 'dd/MM HH:mm'}}</div>
            <div class="d-inline-block ml-2 user">{{item.user.username}}</div>
          </div>
          <div class="pipeline-link">
            <a class="mr-2" href="{{item.pipeline.web_url}}" target="_blank"><i
              class="fal fa-grip-lines mr-2"></i>{{item.pipeline.id}}</a>
            <a *ngIf="item.testSummary && item.testSummary.total.count > 0" href="{{item.pipeline.web_url}}/test_report"
               target="_blank"><i class="fal fa-tachometer-fastest ml-2 mr-2"></i>tests</a>
          </div>
        </div>
        <div class="col-6">
          <div class="d-flex flex-row">
            <ng-container *ngFor="let stage of getStages(item); first as firstStage; last as lastStage;">
              <div [ngClass]="{'pl-3': !firstStage, 'pr-3': !lastStage, 'stage-separator': !lastStage}"
                   class="stage d-flex flex-column">
                <div class="stage-header">{{stage}}</div>
                <div class="stage-jobs d-flex flex-row justify-content-center">
                  <div *ngFor="let job of getJobs(item, stage); first as firstJob; last as lastJob;"
                       [ngClass]="{'ml-1': !firstStage, 'mr-1': !lastStage}"
                       [title]="job.name" class="job" data-toggle="tooltip">
                    <a class="job-link" href="{{job.web_url}}" target="_blank">
                  <i [ngClass]="{
                        'fa-check-circle': job.status === 'success',
                        'fa-dot-circle': job.status === 'created',
                        'fa-exclamation-circle': job.status === 'failed',
                        'fa-stop-circle': job.status === 'skipped',
                        'fa-power-off': job.status === 'canceled',
                        'fa-stopwatch': job.status === 'pending',
                        'fa-spin': job.status === 'running',
                        'fa-circle-notch': job.status === 'running',
                        'fa-play-circle': job.status === 'manual'}"
                     class="fas icon {{job.status}}"></i>
                    </a>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
